import { Resource } from "../resource/resource.model";

export class ContactDetails extends Resource {
    emailAddress: string;
    coreContactFieldId: string;
    value: string;
    tenantId: string;
}
